import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { DataProtectionRulesComponent } from './component/data-protection-rules.component';

import { ApplicationClientCommonModule } from '@sdbn/appclient';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    ServiceResponseModule,
    ApplicationClientCommonModule
  ],
  declarations: [
    DataProtectionRulesComponent
  ]
})
export class DataProtectionRulesModule { }

